import {useDispatch, useSelector} from 'react-redux'
import {useMemo, useEffect, useRef} from 'react'
import {
  setSelectedGeoBoundary as setSelectedGeoBoundaryAction,
  setGeoBoundaryInitialized,
  selectSelectedGeoBoundary,
  selectIsGeoBoundaryInitialized
} from '../slices/geographicBoundarySlice'
import {useStatesAndHealthConditions} from './breadCrumbs'
import {useConfig} from './config'
import {usePermission} from './permission'

export const useGeograhicBoundary = () => {
  const dispatch = useDispatch()
  const selectedGeoBoundary = useSelector(selectSelectedGeoBoundary)
  const isInitialized = useSelector(selectIsGeoBoundaryInitialized)
  const {filters} = useStatesAndHealthConditions()
  const stateLength = filters?.find((value) => value.key === 'state')?.values.length
  const configData = useConfig()
  const geoConfig = configData?.geoBoundaryConfig || {}
  const geographicsBoundary =
    geoConfig && Object.keys(geoConfig).length > 0
      ? Object.keys(geoConfig).map((geographicBoundaryValue) => ({
          value: geographicBoundaryValue,
          label: geoConfig[geographicBoundaryValue].label
        }))
      : []

  const {permission} = usePermission()
  const dataAggregationValue = permission?.healthEquityConditionList?.dataAggregationPermissions

  const prevValuesRef = useRef({stateLength, dataAggregationValue})

  useEffect(() => {
    const prevStateLength = prevValuesRef.current.stateLength
    const prevDataAgg = prevValuesRef.current.dataAggregationValue

    const stateLengthChanged = prevStateLength !== stateLength
    const dataAggChanged = JSON.stringify(prevDataAgg) !== JSON.stringify(dataAggregationValue)

    if (isInitialized && !stateLengthChanged && !dataAggChanged) {
      return
    }

    prevValuesRef.current = {stateLength, dataAggregationValue}

    if (stateLength >= 1) {
      dispatch(setSelectedGeoBoundaryAction('county'))
    } else {
      dispatch(setSelectedGeoBoundaryAction('state'))
    }
    if (dataAggregationValue?.includes(2)) {
      dispatch(setSelectedGeoBoundaryAction('county'))
    } else if (dataAggregationValue?.includes(3)) {
      dispatch(setSelectedGeoBoundaryAction('state'))
    } else if (dataAggregationValue?.includes(5)) {
      dispatch(setSelectedGeoBoundaryAction('congressionaldistrict'))
    } else if (dataAggregationValue?.includes(6)) {
      dispatch(setSelectedGeoBoundaryAction('censustract'))
    }
    dispatch(setGeoBoundaryInitialized(true))
  }, [stateLength, dataAggregationValue, dispatch, isInitialized])

  const setSelectedGeoBoundary = (value) => {
    dispatch(setSelectedGeoBoundaryAction(value))
  }

  return useMemo(
    () => ({
      selectedGeoBoundary,
      setSelectedGeoBoundary,
      geographicsBoundary
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedGeoBoundary, geographicsBoundary]
  )
}
